window.onload = function () {
    fetch('https://www.cloudflare.com/cdn-cgi/trace')
        .then(res => res.text())
        .then(res => {
            const country_code = res.replace(/(\r\n|\n|\r)/gm, '').split('loc=')[1].split('tls=')[0]
            console.log(country_code);
            if (country_code === 'IN' || country_code === 'PK') {
                document.body.style.display = 'none'
                alert('Sorry, you are not allowed to access this site!')
            } else {
                document.body.style.display = 'block'
            }
          if (country_code === 'PK') {
             let country_is_show = document.querySelector(".country-recommend")
             country_is_show.style.display = "block"
             country_is_show.style.height = "50px"
            }
        })
}